import Home from '@/components/home/index'
import ArticleContent from '@/components/article/content'
import CompanyIntroduce from '@/components/company/introduce'
import UserResetPwd from '@/components/user/resetPwd'
import UserEmpty from '@/components/user/empty'
import HomeDownload from '@/components/home/download'

const routes = [
  {
    path: '/',
    name: 'Index',
    component: Home
  }, {
    path: '/index',
    name: 'HomeIndex',
    component: Home
  }, {
    path: '/company/introduce',
    name: 'CompanyIntroduce',
    component: CompanyIntroduce
  }, {
    path: '/article/:id/:sign',
    name: 'ArticleContent',
    component: ArticleContent
  }, {
    path: '/resetPwd/:sign',
    name: 'UserResetPwd',
    component: UserResetPwd
  }, {
    path: '/empty',
    name: 'UserEmpty',
    component: UserEmpty
  }, {
    path: '/download',
    name: 'HomeDownload',
    component: HomeDownload
  }]

export default routes



// WEBPACK FOOTER //
// ./src/router/index.js